import { Component } from '@angular/core';
import { BoardContentsForPost, BoardService, BoardContentDetail, BoardContentsForPatch, AlertService, BoardDetail, CallBack } from 'app/services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector:'board-write',
  templateUrl: 'write.html',
})
export class BoardWriteComponent {
  contents: BoardContentsForPost = new BoardContentsForPost();
  contentsPatch: BoardContentsForPatch = new BoardContentsForPatch();
  boardDetail: BoardDetail = new BoardDetail();
  url:string;
  subject:string;
  title: string;
  description:string;
  keywords:string;
  cntntNo:number;

  contentHtml: string;

  statusCd: string;
  isEditing:boolean = false;

  ckEditorConfig = {
    extraPlugins: 'divarea, resize, image2, image, wysiwygarea, templates',
    contentsCss: '/dist/styles/style.css',
    uiColor: '##fffa65',
    height: 500,
  };
  // extraPlugins: 'easyimage'
  // cloudServices_uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/',

  bbsId: number;
  cntntId:number;
  
  constructor(private route: ActivatedRoute, private boardService:BoardService, private alertService: AlertService, private router: Router) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if(params['bbsId']) {
        this.contents.bbsId = params['bbsId'];
        this.bbsId = params['bbsId'];
      }
      if(params['cntntId']) {
        this.contentsPatch.cntntId = params['cntntId'];
        this.contentsPatch.bbsId = params['bbsId'];
        this.bbsId = params['bbsId'];
        this.cntntId = params['cntntId'];
        this.getBoardDetail();
      }
    }); 
  }

  getBoardDetail() {
    this.boardService.getBoardContentDetail(this.contentsPatch.bbsId, this.contentsPatch.cntntId).subscribe(
      resp => {
        this.boardDetail = resp.data;

        this.url = this.boardDetail.cntntUrl;
        this.subject = this.boardDetail.subject;
        
        if(this.boardDetail.contentDetail.headerContent != null && this.isJson(this.boardDetail.contentDetail.headerContent)) {
          let headerContent = JSON.parse(this.boardDetail.contentDetail.headerContent);
          this.title = headerContent['title'];
          this.keywords = headerContent['keywords'];
          this.description = headerContent['description'];
        }
        
        this.cntntNo = this.boardDetail.cntntNo;
        this.contentHtml = this.boardDetail.contentDetail.content;
        this.statusCd = this.boardDetail.statusCd;
        this.isEditing = true;
      }
    )
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }


  contentsFix(selectedContent) {
    let headerContent = {
      title: this.title,
      description: this.description,
      keywords: this.keywords
    };

    selectedContent.boardContentDetailParam = new BoardContentDetail();
    selectedContent.boardContentDetailParam.content = this.contentHtml;
    selectedContent.boardContentDetailParam.headerContent = JSON.stringify(headerContent);

    selectedContent.cntntUrl = this.url;
    selectedContent.subject = this.subject;
    selectedContent.cntntNo = this.cntntNo;
  }


  handleClickPost() {
    this.contentsFix(this.contents);

    this.boardService.postBoardContents(this.contents.bbsId, this.contents).subscribe(
      resp => {
        if(resp.result) {
          this.alertService.success('새 게시글이 등록되었습니다.');
          this.router.navigate(['board', 'list', this.bbsId]);
        } else {
          this.alertService.error(resp.errerMsg)  
        }
      },
      err => {
        this.alertService.error(err.errerMsg)
      }
    )
  }

  handleClickPostPatch() {
    this.contentsFix(this.contentsPatch);

    this.boardService.patchBoardContents(this.contentsPatch.bbsId, this.contentsPatch.cntntId, this.contentsPatch).subscribe(
      resp => {
        if(resp.result) {
          this.alertService.success('저장 되었습니다.');
          this.getBoardDetail();
        } else {
          this.alertService.error(resp.errerMsg)  
        }
      }
    )
  }

  handleClickPostPatchStatus() {
    let newStatus = null;
    let message = null;
    if(this.statusCd == 'NORMAL') {
      newStatus = 'TEMPORARILY';
      message = '비공개로 변경되었습니다.';
    } else {
      newStatus = 'NORMAL';
      message = '공개로 변경되었습니다.';
    }

    this.boardService.patchBoardStatus(this.contentsPatch.bbsId, this.contentsPatch.cntntId, newStatus).subscribe(
      resp => {
        if(resp.result) {
          this.alertService.success(message);
          this.getBoardDetail();
        }
      }
    )
  }

  handleClickViewList() {
    this.router.navigate(['board', 'list', this.bbsId]);
  }

  handleClickPreview() {
    this.router.navigate(['board', 'preview', this.bbsId, this.cntntId]);
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/board/write.ts